import { ReactElement } from 'react';
import { RightTabCountProps } from '.';

export const RightTabCount = (props: RightTabCountProps): ReactElement => {
	const { count, className } = props;
	return <div className={`${className ?? ''} count-number`}>Total Count: {count}</div>;
};
